import React, { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import styled from 'styled-components';
import {
  LoadingStrategyOption,
  RecommendationType,
} from '@/webapi/use-widget-catalog-api';
import { getAvailableStrategies } from '@/features/editor/widgets/custom-widget/loading-section/util';

type Props = {
  onSelect: (value: LoadingStrategyOption) => () => void;
};

export function StrategySelection({ onSelect }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const strategies = getStrategies();
  return (
    <Popover
      onClickOutside={() => setIsOpen(false)}
      clickOutsideCapture
      positions={[`bottom`, `top`]}
      isOpen={isOpen}
      containerStyle={{ zIndex: `99999` }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowClassName="change-target-arrow"
          arrowSize={10}
        >
          <Strategies>
            {strategies?.map((value) => (
              <Strategy onClick={onSelect(value)}>{value.label}</Strategy>
            ))}
          </Strategies>
        </ArrowContainer>
      )}
    >
      <button type="button" onClick={() => setIsOpen(!isOpen)}>
        Select Strategy
      </button>
    </Popover>
  );
}

const Strategy = styled.span`
  margin: 1.3rem 0 0 0;
  text-transform: capitalize;
  user-select: none;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
  &:active {
    cursor: default;
    opacity: 1;
  }
`;

const Strategies = styled.div`
  font-family: 'Inter', serif;
  color: #8b97a2;
  font-weight: 500;
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  padding: 1rem 2rem 2rem;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 0.1);
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.18),
    0 14px 16px 0 rgba(177, 217, 203, 0.18), 0 5px 16px 0 rgba(0, 0, 0, 0.05);
`;

function getStrategies() {
  const list = getAvailableStrategies();
  return (
    list?.options?.filter?.(
      (s) =>
        ![
          RecommendationType.MANUAL,
          RecommendationType.ADVANCED_RULING,
        ].includes(s.value.type),
    ) || []
  );
}
